module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Food/Burger-947b6522fedc0157f1f793b18a7159c79a68eaefd9e81dc7708f97856abb8086.svg";